import { render, staticRenderFns } from "./orders-income.vue?vue&type=template&id=23ccadc0"
import script from "./orders-income.vue?vue&type=script&lang=js"
export * from "./orders-income.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports